export default {
  namespaced: true,
  state: {
    mobile: "",
  },
  mutations: {
    updateMobile(state, val) {
      sessionStorage.setItem("mobile", val);
      state.mobile = val;
    },

    logout(state, val) {
      state.mobile = val;
    },
  },
  actions: {
    updateMobile: ({ commit }, data) => {
      commit("updateMobile", data);
    },
    logout: ({ commit }, data) => {
      sessionStorage.removeItem("mobile");
      commit("logout", data);
    },
  },
  getters: {
    mobile: (state) => state.mobile,
  },
};
